<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col  md="3" cols="12">    
                                            <v-autocomplete
                                                label="From Warehouse"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                v-model="from_warehouse_id.value.value"
                                                :error-messages="from_warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>  
                                        </v-col>
                                        
                                        <v-col  md="3" cols="12">
                                            <v-autocomplete
                                                label="To Warehouse"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                v-model="to_warehouse_id.value.value"
                                                :error-messages="to_warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">                                
                                            <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>


        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item Transfer Record</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/inventory/add-transfer')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Transfer
                                                </v-btn>
                                            </div>
                                        </v-col> 
                                    </v-row>                   
                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"                    
                                    density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template> 

                                        <template v-slot:item.approval_status_display="{ item }">
                                            <v-chip
                                            v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                            color="yellow-darken-3"
                                            size="small"
                                            >
                                                Wating for {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                            color="green"
                                            size="small"
                                            >
                                                Approved By {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                            color="red"
                                            size="small"
                                            >
                                                Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else
                                            color="green"
                                            size="small"
                                            >
                                                {{ item.approval_status }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip
                                                :color="statusMap[item.status]?.color || 'grey'"
                                                size="small"
                                                class="text-capitalize"
                                            >
                                            {{ statusMap[item.status]?.label || 'Unknown' }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath) && item.status == '0' && canEdit(item)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="viewItem(item)"
                                            >
                                                mdi-file-document-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import statusMap from '@/utils/statusMap';

export default {
        components: {

        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            statusMap,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Transfer Code", key: "code",align: "center" ,sortable: false },
                { title: "From Warehouse",align: "end", key: "from_warehouse.name", sortable: true },
                { title: "To Warehouse",align: "end", key: "to_warehouse.name", sortable: true },
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            if (this.$store.getters.getWarehouseList.length === 0) {
                this.$store.dispatch("getWarehouseList");
            }
        },
        computed:{
            getSchema() {
                return this.$store.getters.getInvItemTransferList;
            },
            getWarehouseList() {
                return this.$store.getters.getWarehouseList;
            },
        },
        setup() {
            const { handleSubmit } = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('Rfq Date'),
                    // department_id: yup.number().positive().integer().nullable().label('Department Name'),
                    // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),                  
                }),
            });

            const from_warehouse_id = useField('from_warehouse_id');
            const to_warehouse_id = useField('to_warehouse_id');
            const errorMessages  = ref('');
            const loading  = ref('');
            const store = useStore();
            const submit = handleSubmit((values) => {
                loading.value = true;

                store.dispatch("getInvItemTransferList", values)
                    .then((response) => {
                        loading.value = false;
                    })
                    .catch((error) => {            
                        toast.error(error.response.data.message);
                    })
            });
            return {
                submit,
                from_warehouse_id,
                to_warehouse_id,
                errorMessages,
                loading
            }
        },
        methods: {
            goTo(val) {
                this.$router.push({ path: val }).catch((err) => {});
            },
            viewItem(item){
                // console.log(item);return;
                this.$router.push({
                    name: 'transfer-record-view',
                    query: { id: item.id }
                });
            },
            editItem(item){
                this.$router.push({
                    name: 'add-transfer',
                    query: { id: item.id }
                });
            },
            canEdit(item){
            return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Transfer Code', 'From warehouse', 'To warehouse', 'Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.from_warehouse.name, item.to_warehouse.name, item.status == 1 ? 'SUBMITTED' : 'DRAFT']);
                this.$exportTableToPDF(columns,rows,'Item Transfer Record','item_transfer_record_' + this.$fileDate(),'landscape')
            },
            exportToExcel() {
                var data = [['#SL', 'Transfer Code', 'From warehouse', 'To warehouse', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.from_warehouse.name, item.to_warehouse.name, item.status == 1 ? 'SUBMITTED' : 'DRAFT']);
                });
                this.$exportTableToExcel(data,'item_transfer_record_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Transfer Code', 'From warehouse', 'To warehouse', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.from_warehouse.name, item.to_warehouse.name, item.status == 1 ? 'SUBMITTED' : 'DRAFT']);
                });

                this.$exportTableToCSV(data,'item_transfer_record_' + this.$fileDate());
            },
        },
        mounted() {
            // this.from_date.value.value = new Date();
            // this.to_date.value.value = new Date();
            this.$nextTick(() => {
                this.$refs.searchButton.$el.click();
            });   
        }  
    }
</script>